<script>
    import Icon from "fa-svelte";
    import { faCaretRight } from "@fortawesome/free-solid-svg-icons";
    import { getAssetURL } from "../../common/assets";
    import { link } from "svelte-routing";
    export let course;
    export let active = true;
</script>

<style>
    .rounded-xl {
        max-width: 30em;
    }
</style>

<a
    use:link
    href={active ? `/courses/${course.uid}` : null}
    class="rounded-xl elevation-2 overflow-hidden flex flex-col">
    <img
        src={getAssetURL(course.picture)}
        class="object-cover w-full"
        alt="Course" />
    <div class="p-2 flex-grow">
        <h2 class="text-xl">{course.name}</h2>
        <p>{course.shortDescription}</p>
    </div>
    <div
        class="p-3 bg-blue-500 text-white flex justify-between text-xl
        items-center">
        <span>{course.price}€</span>
        <Icon icon={faCaretRight} />
    </div>
</a>
